<template>
  <OptionalRouterLink
    v-slot="{ isActive, href, navigate } = {}"
    :to="routeTo"
  >
    <li
      class="NavigationEntry menu-item"
      :class="{ '-active': isActive }"
      v-bind="$attrs"
    >
      <component
        :is="routeTo ? 'a' : 'button'"
        class="main-link"
        :href="href"
        @click="navigate"
      >
        <span>
          <FAIcon
            v-if="item.icon"
            fixed-width
            class="fa-scale-110 menu-icon"
            :icon="item.icon"
          />
        </span>
        <img
          v-if="item.iconEmojiUrl"
          class="menu-icon iconEmoji iconEmoji-image"
          :src="item.iconEmojiUrl"
          :alt="item.iconEmoji"
          :title="item.iconEmoji"
        >
        <span
          v-else-if="item.iconEmoji"
          class="menu-icon iconEmoji"
        >
          <span>
            {{ item.iconEmoji }}
          </span>
        </span>
        <span
          v-else-if="item.iconLetter"
          class="icon iconLetter fa-scale-110 menu-icon"
        >{{ item.iconLetter }}</span>
        <span class="label">
          {{ item.labelRaw || $t(item.label) }}
        </span>
      </component>
      <div
        v-if="item.badgeGetter && badges[item.badgeGetter]"
        class="badge"
        :class="[`-${item.badgeStyle}`]"
      >
        {{ badges[item.badgeGetter] }}
      </div>
      <button
        v-if="pinnable && currentUser"
        type="button"
        class="button-unstyled pin-button"
        :class="{ '-pinned': pinned }"
        :title="$t(pinned ? 'nav.unpin_feed' : 'nav.pin_feed')"
        :aria-label="$t('nav.pin_feed')"
        :aria-pressed="pinned ? 'true' : 'false'"
        @click.stop.prevent="togglePin(item.name)"
      >
        <FAIcon
          fixed-width
          icon="thumbtack"
          :transform="pinned ? '' : 'rotate-45'"
        />
      </button>
    </li>
  </OptionalRouterLink>
</template>

<script src="./navigation_entry.js"></script>

<style lang="scss">
.NavigationEntry.menu-item {
  /* the pin shows on the row under the pointer, and when it is pinned */
  .pin-button {
    line-height: var(--__line-height);
    width: 100%;
    color: var(--textFaint);
  }

  /* with a pointer that can hover: only on the row under it (or in focus);
     hidden, it takes no clicks */
  @media (hover: hover) {
    .pin-button:not(.-pinned) {
      opacity: 0;
      pointer-events: none;
    }

    &:hover .pin-button,
    &:focus-within .pin-button {
      opacity: 1;
      pointer-events: auto;
    }
  }

  .pin-button.-pinned {
    color: inherit;
    opacity: 1;
  }

  --__line-height: 2.5em;
  --__horizontal-gap: 0.5em;
  --__vertical-gap: 0.4em;

  padding: var(--__vertical-gap) var(--__horizontal-gap);
  display: grid;
  grid-template-columns: 1fr;
  grid-auto-columns: var(--__line-height);
  grid-auto-flow: column;
  gap: var(--__horizontal-gap);
  align-items: baseline;

  .main-link {
    line-height: var(--__line-height);
    box-sizing: border-box;
  }

  .menu-icon {
    line-height: var(--__line-height);
    padding: 0;
    width: var(--__line-height);
    margin-right: var(--__horizontal-gap);
  }

  .badge {
    justify-self: center;
  }

  .iconEmoji {
    display: inline-block;
    text-align: center;
    object-fit: contain;
    vertical-align: middle;
    height: var(--__line-height);
    width: var(--__line-height);

    > span {
      font-size: 1.5rem;
    }
  }

  img.iconEmoji {
    padding: 0.25rem;
    box-sizing: border-box;
  }
}
</style>
